module.exports = __webpack_public_path__ + "02d691f985a506cb03e63ee86625829d.svg";